import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mall-head__util" }
const _hoisted_2 = { class: "mall-head__util-inner" }
const _hoisted_3 = { class: "mall-head__util-links" }
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = {
  key: 0,
  class: "mall-head__notify-dot"
}
const _hoisted_6 = {
  key: 0,
  class: "mall-head__notify-panel"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "mall-head__notify-empty"
}
const _hoisted_10 = ["aria-expanded", "title"]
const _hoisted_11 = {
  key: 0,
  class: "mall-head__account-panel"
}
const _hoisted_12 = { class: "mall-head__account-name" }
const _hoisted_13 = ["aria-expanded"]
const _hoisted_14 = { class: "mall-head__main" }
const _hoisted_15 = { class: "mall-head__main-inner" }
const _hoisted_16 = { class: "mall-head__brand-row" }
const _hoisted_17 = { class: "mall-head__brand-name" }
const _hoisted_18 = { class: "mall-head__phone-tools" }
const _hoisted_19 = {
  key: 0,
  class: "mall-head__phone-badge"
}
const _hoisted_20 = {
  key: 0,
  class: "mall-head__phone-badge"
}
const _hoisted_21 = ["aria-expanded", "title"]
const _hoisted_22 = {
  key: 0,
  class: "mall-head__account-panel"
}
const _hoisted_23 = { class: "mall-head__account-name" }
const _hoisted_24 = ["aria-expanded"]
const _hoisted_25 = {
  key: 1,
  class: "mall-head__suggest",
  role: "listbox"
}
const _hoisted_26 = {
  key: 0,
  class: "mall-head__suggest-block"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "mall-head__suggest-block"
}
const _hoisted_30 = { class: "mall-head__suggest-head" }
const _hoisted_31 = { class: "mall-head__suggest-chips" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  class: "mall-head__actions",
  "aria-label": "쇼핑 메뉴"
}
const _hoisted_34 = { class: "mall-head__action-icon" }
const _hoisted_35 = {
  key: 0,
  class: "mall-head__badge"
}
const _hoisted_36 = { class: "mall-head__action-icon" }
const _hoisted_37 = { class: "mall-head__action-icon" }
const _hoisted_38 = {
  key: 0,
  class: "mall-head__badge"
}
const _hoisted_39 = { class: "mall-head__cats-inner" }
const _hoisted_40 = ["href", "aria-current", "onClick"]

import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import MallLoginModal from '@/components/mall/MallLoginModal.vue'
import { ensureLiveProducts } from '@/api/mall'
import { fetchMallNotifies, markMallNotifiesRead, type MallNotifyItem } from '@/api/mallNotify'
import { useCart } from '@/composables/useCart'
import { useAdminAuth } from '@/composables/useAdminAuth'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { useRecentSearches } from '@/composables/useRecentSearches'
import { useWishlist } from '@/composables/useWishlist'
import { useSellerAuth } from '@/composables/useSellerAuth'
import { useSellerCenter } from '@/composables/useSellerCenter'
import { staffManagePath } from '@/composables/useUnifiedLogin'
import { clearMallHeaderOffset, publishMallHeaderOffset } from '@/composables/useMallHeaderOffset'
import {
  MALL_CART_PATH,
  MALL_HOME_PATH,
  MALL_MYPAGE_PATH,
  MALL_NAME,
  MALL_ORDERS_PATH,
  MALL_SHIPPING_PATH,
  MALL_WISHLIST_PATH,
  mallProductPath,
} from '@/constants/mall'
import { MALL_CATEGORY_META, formatPrice, getAllProducts } from '@/constants/mallProducts'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallHeader',
  setup(__props) {

const route = useRoute()
const showCategories = computed(() => route.name !== 'mall-signup')
const isMallHome = computed(() => route.path === MALL_HOME_PATH)
const router = useRouter()
const { productCount } = useCart()
const { wishCount } = useWishlist()
const { recentSearches, pushSearch, clearSearches } = useRecentSearches()
const { isLoggedIn, member, logout } = useMemberAuth()
const { admin, isAdminLoggedIn, initAdminAuth, logout: logoutAdmin } = useAdminAuth()
const { seller, canOpen: canOpenSellerCenter, refreshSellerAuth } = useSellerCenter()
const { logout: logoutSeller } = useSellerAuth()
const managePageTo = computed(() =>
  staffManagePath({
    isAdmin: isAdminLoggedIn.value,
    isSeller: canOpenSellerCenter.value,
    seller: seller.value,
  }),
)

const keyword = ref(typeof route.query.q === 'string' ? route.query.q : '')
const stuck = ref(false)
const loginOpen = ref(false)
const loginButtonRef = ref<HTMLButtonElement | null>(null)
const accountOpen = ref(false)
const accountRef = ref<HTMLElement | null>(null)
const phoneAccountRef = ref<HTMLElement | null>(null)
const notifyOpen = ref(false)
const notifyRef = ref<HTMLElement | null>(null)
const notifies = ref<MallNotifyItem[]>([])
const unreadCount = ref(0)
const searchRef = ref<HTMLElement | null>(null)
const suggestOpen = ref(false)
const categories = MALL_CATEGORY_META

const suggestProducts = computed(() => {
  const q = keyword.value.trim().toLowerCase()
  const all = getAllProducts()
  if (!q) return all.slice(0, 5)
  return all
    .filter((product) => product.name.toLowerCase().includes(q))
    .slice(0, 6)
})

function openSuggest() {
  suggestOpen.value = true
}

function closeSuggest() {
  suggestOpen.value = false
}

function goSearch(q: string) {
  keyword.value = q
  pushSearch(q)
  closeSuggest()
  router.push({ path: MALL_HOME_PATH, query: { q } })
}

function goProduct(id: string) {
  closeSuggest()
  router.push(mallProductPath(id))
}

function categoryTo(id: string) {
  if (id === '전체') return { path: MALL_HOME_PATH, query: {} }
  return { path: MALL_HOME_PATH, query: { cat: id } }
}

function isCategoryActive(id: string) {
  if (route.path !== MALL_HOME_PATH) return false
  const current = typeof route.query.cat === 'string' ? route.query.cat : ''
  if (id === '전체') return !current
  return current === id
}

const personName = computed(
  () => member.value?.bossName?.trim() || member.value?.userId || '회원',
)
const welcomeName = computed(
  () => member.value?.orgName?.trim() || personName.value,
)
const phoneAccountName = computed(() => {
  if (isLoggedIn.value) return welcomeName.value
  if (isAdminLoggedIn.value) return admin.value?.name?.trim() || admin.value?.userId || '관리자'
  if (canOpenSellerCenter.value) {
    return (
      seller.value?.storeName?.trim()
      || seller.value?.ownerName?.trim()
      || seller.value?.sellerId
      || '판매업체'
    )
  }
  return ''
})
const phoneAccountTitle = computed(() => (isLoggedIn.value ? personName.value : phoneAccountName.value))
const myInfoActive = computed(
  () => route.path.startsWith(MALL_MYPAGE_PATH) && !route.path.startsWith(MALL_WISHLIST_PATH),
)

watch(
  () => route.query.q,
  (q) => {
    keyword.value = typeof q === 'string' ? q : ''
  },
)

watch(
  () => route.fullPath,
  () => {
    loginOpen.value = false
    accountOpen.value = false
    notifyOpen.value = false
  },
)

watch(isLoggedIn, (loggedIn) => {
  if (loggedIn) void loadNotifies()
  else {
    notifies.value = []
    unreadCount.value = 0
  }
})

const badgeText = (count: number) => (count > 99 ? '99+' : String(count))

function submitSearch() {
  const q = keyword.value.trim()
  if (q) pushSearch(q)
  closeSuggest()
  router.push({ path: MALL_HOME_PATH, query: q ? { q } : {} })
}

function clearSearch() {
  keyword.value = ''
  if (route.path === MALL_HOME_PATH && route.query.q) {
    router.push({ path: MALL_HOME_PATH })
  }
}

async function loadNotifies() {
  if (!isLoggedIn.value) return
  try {
    const result = await fetchMallNotifies()
    notifies.value = result.items
    unreadCount.value = result.unread
  } catch {
    notifies.value = []
    unreadCount.value = 0
  }
}

function toggleNotify() {
  notifyOpen.value = !notifyOpen.value
  accountOpen.value = false
  if (notifyOpen.value) void loadNotifies()
}

async function openNotify(item: MallNotifyItem) {
  notifyOpen.value = false
  try {
    unreadCount.value = await markMallNotifiesRead(item.idx)
    const found = notifies.value.find((row) => row.idx === item.idx)
    if (found) found.read = true
  } catch {
    /* 읽음 실패해도 화면은 연다 */
  }
  /* 문의 답변 알림은 orderCode 자리에 상품 코드가 들어 있다 */
  if (item.type === 'QNA_ANSWER' && item.orderCode) {
    await router.push(`/mall/products/${encodeURIComponent(item.orderCode)}`)
    return
  }
  if (item.orderCode) {
    await router.push(`/mall/orders/${encodeURIComponent(item.orderCode)}`)
    return
  }
  await router.push(MALL_ORDERS_PATH)
}

let accountCloseTimer = 0

function openAccount() {
  window.clearTimeout(accountCloseTimer)
  accountOpen.value = true
  notifyOpen.value = false
}

function closeAccountSoon() {
  window.clearTimeout(accountCloseTimer)
  accountCloseTimer = window.setTimeout(() => {
    accountOpen.value = false
  }, 160)
}

function toggleAccount() {
  window.clearTimeout(accountCloseTimer)
  accountOpen.value = !accountOpen.value
  notifyOpen.value = false
}

function closeAccount() {
  window.clearTimeout(accountCloseTimer)
  accountOpen.value = false
}

function openLogin() {
  accountOpen.value = false
  notifyOpen.value = false
  suggestOpen.value = false
  loginOpen.value = true
}

function closeLogin() {
  loginOpen.value = false
  void nextTick(() => loginButtonRef.value?.focus())
}

async function onLoginSuccess() {
  loginOpen.value = false
}

async function leaveMall() {
  await router.push('/')
}

async function onStaffLogout() {
  closeAccount()
  if (isAdminLoggedIn.value) await logoutAdmin()
  if (canOpenSellerCenter.value) await logoutSeller()
  await leaveMall()
}

async function onLogout() {
  closeAccount()
  await logout()
  await leaveMall()
}

const onScroll = () => {
  stuck.value = window.scrollY > 8
  syncHeaderOffset()
}

const onDocClick = (event: MouseEvent) => {
  const target = event.target as Node
  const inAccount = Boolean(
    (accountRef.value && accountRef.value.contains(target))
    || (phoneAccountRef.value && phoneAccountRef.value.contains(target)),
  )
  if (accountOpen.value && !inAccount) {
    accountOpen.value = false
  }
  if (notifyOpen.value && notifyRef.value && !notifyRef.value.contains(target)) {
    notifyOpen.value = false
  }
  if (suggestOpen.value && searchRef.value && !searchRef.value.contains(target)) {
    suggestOpen.value = false
  }
}

const onKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    accountOpen.value = false
    notifyOpen.value = false
    suggestOpen.value = false
  }
}

let offsetRaf = 0
let offsetObserver: ResizeObserver | null = null
const syncHeaderOffset = () => {
  if (offsetRaf) return
  offsetRaf = window.requestAnimationFrame(() => {
    offsetRaf = 0
    publishMallHeaderOffset()
  })
}

onMounted(() => {
  onScroll()
  void initAdminAuth()
  refreshSellerAuth()
  ensureLiveProducts()
  void loadNotifies()
  syncHeaderOffset()
  const head = document.querySelector('.mall-head')
  if (head && typeof ResizeObserver !== 'undefined') {
    offsetObserver = new ResizeObserver(() => syncHeaderOffset())
    offsetObserver.observe(head)
  }
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', syncHeaderOffset, { passive: true })
  document.addEventListener('click', onDocClick)
  window.addEventListener('keydown', onKeydown)
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
  window.removeEventListener('resize', syncHeaderOffset)
  document.removeEventListener('click', onDocClick)
  window.removeEventListener('keydown', onKeydown)
  offsetObserver?.disconnect()
  offsetObserver = null
  if (offsetRaf) window.cancelAnimationFrame(offsetRaf)
  window.clearTimeout(accountCloseTimer)
  clearMallHeaderOffset()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: _normalizeClass(["mall-head", { 'mall-head--stuck': stuck.value }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "mall-head__back"
          }, {
            default: _withCtx(() => [
              _createVNode(AppIcon, {
                icon: "mdi-chevron-left",
                size: 16
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mall-head__back-full" }, "장기요양지원센터", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mall-head__back-short" }, "본사이트", -1))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            (_unref(isLoggedIn))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", {
                    ref_key: "notifyRef",
                    ref: notifyRef,
                    class: "mall-head__notify"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "mall-head__util-link mall-head__notify-btn",
                      "aria-expanded": notifyOpen.value,
                      "aria-label": "알림",
                      onClick: _withModifiers(toggleNotify, ["stop"])
                    }, [
                      _createVNode(AppIcon, {
                        icon: "mdi-bell-outline",
                        size: 16
                      }),
                      (unreadCount.value)
                        ? (_openBlock(), _createElementBlock("em", _hoisted_5, _toDisplayString(badgeText(unreadCount.value)), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_4),
                    (notifyOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mall-head__notify-title" }, "알림", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifies.value, (item) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: item.idx,
                              type: "button",
                              class: _normalizeClass(["mall-head__notify-item", { 'is-unread': !item.read }]),
                              onClick: ($event: any) => (openNotify(item))
                            }, [
                              _createElementVNode("strong", null, _toDisplayString(item.title), 1),
                              (item.body)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.body), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_7))
                          }), 128)),
                          (!notifies.value.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "새 알림이 없습니다."))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 512),
                  (managePageTo.value)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: managePageTo.value,
                        class: "mall-head__util-link mall-head__util-link--keep"
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode(" 관리자페이지 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    ref_key: "accountRef",
                    ref: accountRef,
                    class: "mall-head__account",
                    onMouseenter: openAccount,
                    onMouseleave: closeAccountSoon
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["mall-head__welcome", { 'is-open': accountOpen.value }]),
                      "aria-expanded": accountOpen.value,
                      title: personName.value,
                      "aria-haspopup": "true",
                      onClick: _withModifiers(toggleAccount, ["stop"])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(welcomeName.value) + "님 환영합니다", 1),
                      _createVNode(AppIcon, {
                        icon: "mdi-chevron-down",
                        size: 14
                      })
                    ], 10, _hoisted_10),
                    (accountOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(personName.value), 1),
                          _createVNode(_component_router_link, {
                            to: _unref(MALL_MYPAGE_PATH),
                            onClick: closeAccount
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("마이페이지", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: _unref(MALL_ORDERS_PATH),
                            onClick: closeAccount
                          }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("주문내역", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: _unref(MALL_SHIPPING_PATH),
                            onClick: closeAccount
                          }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode("배송지", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "mall-head__account-logout",
                            onClick: onLogout
                          }, " 로그아웃 ")
                        ]))
                      : _createCommentVNode("", true)
                  ], 544)
                ], 64))
              : (managePageTo.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_router_link, {
                      to: managePageTo.value,
                      class: "mall-head__util-link mall-head__util-link--keep"
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" 관리자페이지 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "mall-head__util-link mall-head__util-link--keep",
                      onClick: onStaffLogout
                    }, " 로그아웃 ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("button", {
                      ref_key: "loginButtonRef",
                      ref: loginButtonRef,
                      type: "button",
                      class: "mall-head__util-link mall-head__util-link--keep",
                      "aria-haspopup": "dialog",
                      "aria-expanded": loginOpen.value,
                      onClick: openLogin
                    }, " 로그인 ", 8, _hoisted_13),
                    _createVNode(_component_router_link, {
                      to: "/mall/signup",
                      class: "mall-head__util-link mall-head__util-link--keep"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode(" 회원가입 ", -1)
                      ]))]),
                      _: 1
                    })
                  ], 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_router_link, {
              to: _unref(MALL_HOME_PATH),
              class: "mall-head__brand"
            }, {
              default: _withCtx(() => [
                _createVNode(AppIcon, {
                  icon: "mdi-cart-percent",
                  size: 26
                }),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(MALL_NAME)), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_router_link, {
                to: _unref(MALL_WISHLIST_PATH),
                class: _normalizeClass(["mall-head__phone-icon", { 'is-active': _unref(route).path.startsWith(_unref(MALL_WISHLIST_PATH)) }]),
                "aria-label": "찜"
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, {
                    icon: "mdi-heart-outline",
                    size: 22
                  }),
                  (_unref(wishCount))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(badgeText(_unref(wishCount))), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to", "class"]),
              _createVNode(_component_router_link, {
                to: _unref(MALL_CART_PATH),
                class: _normalizeClass(["mall-head__phone-icon", { 'is-active': _unref(route).path.startsWith(_unref(MALL_CART_PATH)) }]),
                "aria-label": "장바구니"
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, {
                    icon: "mdi-cart-outline",
                    size: 22
                  }),
                  (_unref(productCount))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(badgeText(_unref(productCount))), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["to", "class"]),
              (phoneAccountName.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref_key: "phoneAccountRef",
                    ref: phoneAccountRef,
                    class: "mall-head__phone-account"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["mall-head__phone-icon", { 'is-open': accountOpen.value, 'is-active': myInfoActive.value }]),
                      "aria-expanded": accountOpen.value,
                      title: `${phoneAccountName.value}님`,
                      "aria-label": "내정보",
                      "aria-haspopup": "true",
                      onClick: _withModifiers(toggleAccount, ["stop"])
                    }, [
                      _createVNode(AppIcon, {
                        icon: "mdi-account-outline",
                        size: 22
                      }),
                      _createElementVNode("span", null, _toDisplayString(phoneAccountName.value), 1)
                    ], 10, _hoisted_21),
                    (accountOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("p", _hoisted_23, _toDisplayString(phoneAccountTitle.value), 1),
                          (_unref(isLoggedIn))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_router_link, {
                                  to: _unref(MALL_MYPAGE_PATH),
                                  onClick: closeAccount
                                }, {
                                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                    _createTextVNode("마이페이지", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["to"]),
                                _createVNode(_component_router_link, {
                                  to: _unref(MALL_ORDERS_PATH),
                                  onClick: closeAccount
                                }, {
                                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode("주문내역", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["to"]),
                                _createVNode(_component_router_link, {
                                  to: _unref(MALL_SHIPPING_PATH),
                                  onClick: closeAccount
                                }, {
                                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode("배송지", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["to"]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "mall-head__account-logout",
                                  onClick: onLogout
                                }, " 로그아웃 ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (managePageTo.value)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: managePageTo.value,
                                      onClick: closeAccount
                                    }, {
                                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                        _createTextVNode(" 관리자페이지 ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "mall-head__account-logout",
                                  onClick: onStaffLogout
                                }, " 로그아웃 ")
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                  ], 512))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "mall-head__phone-icon",
                    "aria-label": "내정보",
                    onClick: openLogin
                  }, [
                    _createVNode(AppIcon, {
                      icon: "mdi-account-outline",
                      size: 22
                    })
                  ]))
            ])
          ]),
          _createElementVNode("form", {
            ref_key: "searchRef",
            ref: searchRef,
            class: "mall-head__search",
            role: "search",
            onSubmit: _withModifiers(submitSearch, ["prevent"])
          }, [
            _createVNode(AppIcon, {
              class: "mall-head__search-icon",
              icon: "mdi-magnify",
              size: 22
            }),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
              type: "search",
              class: "mall-head__search-input",
              placeholder: "검색어",
              "aria-label": "상품검색",
              "aria-autocomplete": "list",
              "aria-expanded": suggestOpen.value,
              enterkeyhint: "search",
              autocomplete: "off",
              onFocus: openSuggest,
              onInput: openSuggest
            }, null, 40, _hoisted_24), [
              [_vModelText, keyword.value]
            ]),
            (keyword.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "mall-head__search-clear",
                  "aria-label": "검색어 지우기",
                  onClick: clearSearch
                }, [
                  _createVNode(AppIcon, {
                    icon: "mdi-close-circle",
                    size: 18
                  })
                ]))
              : _createCommentVNode("", true),
            _cache[17] || (_cache[17] = _createElementVNode("button", {
              type: "submit",
              class: "mall-head__search-submit"
            }, "검색", -1)),
            (suggestOpen.value && (suggestProducts.value.length || _unref(recentSearches).length))
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (suggestProducts.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mall-head__suggest-label" }, "추천상품", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestProducts.value, (product) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: product.id,
                            type: "button",
                            class: "mall-head__suggest-item",
                            role: "option",
                            onClick: ($event: any) => (goProduct(product.id))
                          }, [
                            (product.image)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: product.image,
                                  alt: ''
                                }, null, 8, _hoisted_28))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, [
                              _createElementVNode("strong", null, _toDisplayString(product.name), 1),
                              _createElementVNode("em", null, _toDisplayString(product.mallKind === 'SALE' ? `1개당 ${_unref(formatPrice)(product.price)}원` : `${_unref(formatPrice)(product.price)}원`), 1)
                            ])
                          ], 8, _hoisted_27))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(recentSearches).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "mall-head__suggest-label" }, "최근 검색어", -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "mall-head__suggest-clear",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(clearSearches) && _unref(clearSearches)(...args)))
                          }, " 전체삭제 ")
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recentSearches), (item) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: item,
                              type: "button",
                              class: "mall-head__suggest-chip",
                              onClick: ($event: any) => (goSearch(item))
                            }, _toDisplayString(item), 9, _hoisted_32))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 544),
          _createElementVNode("nav", _hoisted_33, [
            _createVNode(_component_router_link, {
              to: _unref(MALL_WISHLIST_PATH),
              class: "mall-head__action"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_34, [
                  _createVNode(AppIcon, {
                    icon: "mdi-heart-outline",
                    size: 22
                  }),
                  (_unref(wishCount))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(badgeText(_unref(wishCount))), 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "mall-head__action-label" }, "찜하기", -1))
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: _unref(MALL_MYPAGE_PATH),
              class: "mall-head__action"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_36, [
                  _createVNode(AppIcon, {
                    icon: "mdi-account-outline",
                    size: 22
                  })
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "mall-head__action-label" }, "마이페이지", -1))
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: _unref(MALL_CART_PATH),
              class: "mall-head__action"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_37, [
                  _createVNode(AppIcon, {
                    icon: "mdi-cart-outline",
                    size: 22
                  }),
                  (_unref(productCount))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(badgeText(_unref(productCount))), 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "mall-head__action-label" }, "장바구니", -1))
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      (showCategories.value)
        ? (_openBlock(), _createElementBlock("nav", {
            key: 0,
            class: _normalizeClass(["mall-head__cats", { 'is-home': isMallHome.value }]),
            "aria-label": "상품 카테고리"
          }, [
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (cat) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: cat.id,
                  to: categoryTo(cat.id),
                  custom: ""
                }, {
                  default: _withCtx(({ href, navigate }) => [
                    _createElementVNode("a", {
                      href: href,
                      class: _normalizeClass(["mall-head__cat", { 'is-active': isCategoryActive(cat.id) }]),
                      "aria-current": isCategoryActive(cat.id) ? 'page' : undefined,
                      onClick: navigate
                    }, [
                      _createVNode(AppIcon, {
                        icon: cat.icon,
                        size: 16
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(cat.label), 1)
                    ], 10, _hoisted_40)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(MallLoginModal, {
      open: loginOpen.value,
      "redirect-to": _unref(route).fullPath,
      onClose: closeLogin,
      onSuccess: onLoginSuccess
    }, null, 8, ["open", "redirect-to"])
  ], 64))
}
}

})